/**
 * Применение активного оформления (ТЗ §22).
 *
 * Токены приходят с сервера и подставляются в CSS-переменные, поэтому
 * смена темы и откат не требуют новой сборки. Значения из `tokens.css`
 * остаются запасом: пока тема не загрузилась или сервер недоступен,
 * интерфейс выглядит нормально.
 */
import { useEffect } from 'react'

import { useActiveTheme } from '@/features/site/api'
import { useTheme } from '@/shared/lib/theme'

const STYLE_ID = 'ut-active-theme'

/** Собирает CSS так же, как tokens.css: светлая на :root, тёмная двумя путями. */
function buildCss(light: Record<string, string>, dark: Record<string, string>): string {
  const declarations = (values: Record<string, string>) =>
    Object.entries(values)
      .map(([name, value]) => `${name}: ${value};`)
      .join('')

  return [
    `:root{${declarations(light)}}`,
    `@media (prefers-color-scheme: dark){:root:not([data-theme='light']){${declarations(dark)}}}`,
    `:root[data-theme='dark']{${declarations(dark)}}`,
  ].join('')
}

export function ThemeTokens() {
  const theme = useActiveTheme()
  // Подписываемся на выбор пользователя, чтобы переставить переменные, если
  // он переключил светлую и тёмную схему.
  useTheme()

  const tokens = theme.data?.tokens
  useEffect(() => {
    if (!tokens) return

    let style = document.getElementById(STYLE_ID) as HTMLStyleElement | null
    if (style === null) {
      style = document.createElement('style')
      style.id = STYLE_ID
      // В конец head: правила должны перебить tokens.css, а не наоборот.
      document.head.append(style)
    }
    style.textContent = buildCss(tokens.light, tokens.dark)
  }, [tokens])

  return null
}
